<!-- @format -->

<template>
	<div id="nav" class="flex">
		<div class="lc-account-user flex items-center">
			<div class="lc-favicon mr-1">
				<img src="../assets/lew.jpg" alt="">
			</div> {{ user.name }}({{ user.handicap }}) 
				<a href="#" class="text-white ml-1" @click.prevent="showMainNav = !showMainNav">
					<font-awesome-icon v-if="!showMainNav" icon="chevron-down" />
					<font-awesome-icon v-if="showMainNav" icon="chevron-up" />
				</a>
		</div>
		<img class="top-logo ml-auto" alt="MGS logo" src="../assets/mgs.png" />

		<div class="mgs-nav-container flex flex-col" :class="{'mgs-nav-displaying': showMainNav === true}">
			<router-link v-if="!loggedIn" to="/">Home</router-link>
			<router-link v-if="loggedIn" to="/dashboard">Dashboard</router-link>
			<router-link v-if="!loggedIn" to="/login">Login</router-link>
			<router-link v-if="loggedIn" to="/courses">Courses</router-link>
			<router-link v-if="loggedIn" to="/rounds">Rounds</router-link>
			<router-link v-if="loggedIn" to="/statistics">Statistics</router-link>
			<router-link v-if="loggedIn" to="/shot-analysis">Shot Analysis</router-link>
			<button
				v-if="loggedIn"
				type="button"
				class="logoutButton"
				@click="logout"
			>Logout</button>
		</div>
	</div>
</template>

<script>
/** @format */
import {authComputed} from './../store/helpers.js';
export default {
	computed: {
		...authComputed
	},
	methods: {
		logout() {
			this.$store.dispatch('user/logout');
		}
	},
	data() {
		return {
			showUserNav: false,
			showMainNav: false
		}
	}
};
</script>

<style lang="scss" scoped>
/** @format */
#nav {
	@apply bg-forest-green p-2 text-white;
	position: fixed;
    width: 100%;
    top: 0px;
    z-index: 1000;
	.lc-account-user {
		@apply px-4;
	}
	.lc-favicon {
		width:40px;
		height:40px;
		border-radius: 100px;
		background: white;
		padding: 2px;
		img {
			width: 100%;
			border-radius: 100px;
		}
	}
	.top-logo {
		height:50px;
	}
	.mgs-nav-container{
		@apply bg-white py-4;
		background-color: #fff;
    	position: fixed;
    	left: 0;
		top: 66px;
		width:100%;
		max-width:200px;
		bottom: 0px;
		overflow: auto;
		border-right: 1px solid #cacaca;
		transform: translateX(-200px);
		transition: all 0.3s ease-in-out;
		&.mgs-nav-displaying {
			transform: translateX(0px);
		}
		a {
			@apply px-4 py-1;

		}
	}
	.router-link-active {
		@apply text-forest-green;
	}
}
// #nav {
// 	display: flex;
// 	align-items: center;
// 	min-height: 50px;
// 	padding: 0.2em 1em;

// 	//background: linear-gradient(to right, #16c0b0, #84cf6a);
// 	a {
// 		margin-right: 1em;
// 		border-bottom: none;
// 		position: relative;
// 		color: white;
// 	}
// 	position: relative;
// 	&:before {
// 		content: "";
// 		position: absolute;
// 		top:0px;
// 		left:0px;
// 		width: 100%;
// 		height: 100%;
// 		background: $forestGreen;
// 	}
// }

// .nav-welcome {
// 	margin-left: auto;
// 	margin-right: 1rem;
// 	color: white;
// }

// .router-link-exact-active {
// 	color: lighten(#16c0b0, 30%);
// 	border-bottom: 2px solid #fff !important;
// }

// button,
// .button {
// 	margin-left: auto;
// 	background: white;
// 	text-decoration: none;
// 	color: #2c3e50;

// 	&.router-link-active {
// 		color: #2c3e50;
// 	}
// }

// .logoutButton {
// 	cursor: pointer;
// }

// .nav-welcome + button {
// 	margin-left: 0;
// }
</style>
